import { Close } from '@gympass/yoga-icons';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, Button, Chip, Link, Tooltip, Typography } from '@mui/material';
import { useFlag } from '@unleash/proxy-client-react';
import { differenceInYears } from 'date-fns';
import parsePhoneNumber from 'libphonenumber-js';
import { useIntl } from 'react-intl';
import { FeatureToggle } from 'utils/unleash/toggles';

import { useCareMatrix } from 'hooks/useCareMatrix';

import { Error } from '../components';
import { getCareMatrixProfile } from '../utils';

import { HeaderProps } from './types';

import * as S from './styles';

export function Header({ user, isError }: HeaderProps) {
  const intl = useIntl();
  const isPatientPhoneNumberEnabled = useFlag(FeatureToggle.PhoneNumber);
  const { closeModule } = useCareMatrix();

  function handleCloseModule() {
    closeModule();
  }

  const formatPhoneNumber = () => {
    const phoneNumber = parsePhoneNumber(user?.phoneNumber);
    return phoneNumber?.formatNational();
  };

  const handleAction = () => {
    window.open(
      `https://api.whatsapp.com/send?phone=${user?.phoneNumber}`,
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <Box display="flex" flexDirection="column" gap={0.5} py={2} px={4}>
      <Box display="flex" alignItems="center">
        {!isError ? (
          <Link
            variant="h6"
            href={`enduser/${user?.cognitoID}`}
            flex="1"
            target="_blank"
          >
            {user?.fullName}
          </Link>
        ) : (
          <Box flex={1} />
        )}

        <S.CloseButton onClick={handleCloseModule}>
          <Close />
        </S.CloseButton>
      </Box>
      {!isError ? (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography variant="body2">
            {intl.formatMessage(
              { id: 'CAREMATRIXCPTC.TAG.AGE' },
              {
                date: differenceInYears(new Date(), new Date(user?.birthdate)),
              },
            )}
          </Typography>

          {user?.care_profile && (
            <Tooltip
              title={intl.formatMessage({
                id: 'CAREMATRIXCPTC.TOOLTIP.PROTOCOL',
              })}
              arrow
              placement="top"
            >
              <a
                href={getCareMatrixProfile(user?.care_profile)?.protocol}
                download={intl.formatMessage({
                  id: getCareMatrixProfile(user?.care_profile)?.fileName,
                })}
              >
                <Chip
                  color={getCareMatrixProfile(user?.care_profile)?.color}
                  label={intl.formatMessage({
                    id: getCareMatrixProfile(user?.care_profile)?.profileName,
                  })}
                  size="small"
                />
              </a>
            </Tooltip>
          )}
        </Box>
      ) : (
        <Error />
      )}
      {user?.phoneNumber && isPatientPhoneNumberEnabled && (
        <S.WrapperButton>
          <Button
            onClick={handleAction}
            variant="text"
            startIcon={<WhatsAppIcon />}
          >
            {formatPhoneNumber()}
          </Button>
        </S.WrapperButton>
      )}
    </Box>
  );
}
